import { THEME_COLOR } from "../config/club";

export default function GlobalLogoutLoader() {
  const THEME_VIOLET = THEME_COLOR;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
      style={{
        zIndex: 9999,
        background: "rgba(255, 255, 255, 0.92)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      {/* Spinner */}
      <div
        className="spinner-border mb-3"
        role="status"
        style={{
          width: "3rem",
          height: "3rem",
          borderWidth: "0.3em",
          color: THEME_VIOLET,
        }}
      >
        <span className="visually-hidden">Logging out...</span>
      </div>

      {/* Text */}
      <div
        className="fw-bold text-uppercase"
        style={{
          fontSize: "0.8rem",
          letterSpacing: "0.15em",
          color: "#555",
        }}
      >
        Logging out…
      </div>
    </div>
  );
}
